import { memo } from 'react';
import TextCollectionPerResponseTaskComponent from './TextCollectionPerResponseTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

function TextCollectionPerResponseViewComponent(props: StepViewComponentProps) {
  return <TextCollectionPerResponseTaskComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(TextCollectionPerResponseViewComponent);
